import HundredBricksAPIError from '../../HundredBricksAPIError';
class RegisterPersonalDataError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterPersonalDataError', ...args);
    }
}
export default RegisterPersonalDataError;
